import Vue from 'vue';

export class Maxtrack {

    /**
     *
     * @param idRastreador
     * @returns {Promise}
     */
    static byPK(idRastreador) {
        return new Promise((ok, fail) => {
            Vue.http.get('configuracao-maxtrack/by-pk/' + idRastreador)
                .then((res) => ok(res.data))
                .catch((err) => fail(err));
        });
    }

    static sendTempos(json) {
        return Vue.http.post('configuracao-maxtrack/times', json);
    }
}
